export default "/images/Logo-Thick-Black-watches_jewllery-L-G-UAEfull.svg?0e9a0636c77e5e2ca2a9890274d220f3";